import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { CheckmarkCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './ConfirmationScreen.module.scss';
export const GetConfirmationScreenTID = (parentTestId)=>getTestIds(parentTestId);
export const ConfirmationScreen = (param)=>{
    let { amount, vendorName, testId } = param;
    const { ConfirmationScreenTestIds } = GetConfirmationScreenTID(testId);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": ConfirmationScreenTestIds.Root(),
        className: "".concat(styles.screen, " ").concat(styles.gradualReveal),
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": ConfirmationScreenTestIds.CheckmarkIcon(),
                className: styles.checkmark,
                children: /*#__PURE__*/ _jsx(CheckmarkCircle, {})
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h3",
                testId: ConfirmationScreenTestIds.Title(),
                className: styles.title,
                children: t.adHocInvoiceApproval.confirmation.title()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                testId: ConfirmationScreenTestIds.Subtitle(),
                className: styles.subtitle,
                children: t.adHocInvoiceApproval.confirmation.subtitle({
                    amount: amount.display(),
                    vendorName
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                testId: ConfirmationScreenTestIds.Note(),
                children: t.adHocInvoiceApproval.confirmation.note()
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": ConfirmationScreenTestIds.TryAnchorBanner(),
                className: styles.banner,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: t.adHocInvoiceApproval.confirmation.tryAnchorBanner()
                })
            })
        ]
    });
};
